<template>
  <div class="g-container">
    <div class="m-container m-width">
      <!--            面包屑-->
      <div class="crumbs-box">
        <a class="c-crumbs" href="">匠心记</a>
        <span class="c-sep">&gt;</span>
        <span class="c-current">创建现场基础情况告知流程</span>
      </div>

      <div class="apply-orig-main">
        <div class="apply-orig-hd">
          <ul>
            <!--选中 +active-->
            <li :class="{ active: setp == 1 }">
              <!--                            <h4>第一步</h4>-->
              <p>现场情况编写</p>
              <i></i>
            </li>
            <li :class="{ active: setp == 2 }">
              <!--                            <h4>第二步</h4>-->
              <p>客户告知函编写</p>
              <i></i>
            </li>
            <li :class="{ active: setp == 3 }">
              <!--                            <h4>第三步</h4>-->
              <p>客户确认下单</p>
              <i></i>
            </li>
          </ul>
        </div>
      </div>

      <div class="upload-title">
        <div class="upload-title-sing">签到：</div>
        <div class="upload-sign">
          <span class="upload-sign-positioning">
            <i
              class="el-icon-location"
              style="width: 20px; height: 25px; font-size: 22px"
            ></i>
            <span v-if="position">{{ position.province + position.city }}</span>
            <span v-else>地位位置获取失败，请稍后再试</span>
          </span>
          <span class="upload-sign-right">{{
            new Date().toLocaleDateString()
          }}</span>
        </div>
      </div>

      <div class="content">
        <!--                视频上传-->
        <h5>视频上传（可选）</h5>
        <!-- <uploader class="uploader-example" :options="options" ref="uploader">
          <uploader-unsupport></uploader-unsupport>
          <uploader-btn :attrs="attrs" ref="uploaderBtn" class="uploader-btn" @change="selectFile">
              <div>
                  <i>点击上传</i>
              </div>
          </uploader-btn>
          <video></video>
        </uploader> -->
        <div class="content-upload-video">
<!--          <el-upload-->
<!--            action="none"-->
<!--            ref="videoFile"-->
<!--            list-type="picture-card"-->
<!--            :on-change="fileChange"-->
<!--            :auto-upload="false"-->
<!--            :show-file-list="false"-->
<!--          >-->
<!--            <el-progress-->
<!--              type="circle"-->
<!--              :percentage="uploadFileNum"-->
<!--              v-if="uploadFileNum < 100 && uploadFileNum != 0"-->
<!--            ></el-progress>-->
<!--            <video-->
<!--              :src="videoFile.url"-->
<!--              v-if="videoFile && uploadFileNum >= 100"-->
<!--              width="100%"-->
<!--              height="100%"-->
<!--              autoplay-->
<!--            ></video>-->
<!--            <i-->
<!--              v-if="!videoFile"-->
<!--              slot="default"-->
<!--              class="el-icon-circle-plus-outline"-->
<!--              >点击上传</i-->
<!--            >-->
<!--          </el-upload>-->
          <uploader v-show="show"  :options="options" :file-status-text="statusText" @file-success="fileSuccess"  @file-added="onFileAdded" @file-progress="onFileProgress"
                    @file-error="onFileError" @file-removed="onfileRemoved" class="uploader-example" ref="uploader" >
<!--            <uploader-unsupport ></uploader-unsupport>-->

            <uploader-btn >
              <p class="upload-btnP">
                <img class="SC" src="./SC.png"/>
                <span> 上传视频  </span>
              </p>
            </uploader-btn>
          </uploader>
          <uploader-drop v-show="showVideo">
            <!--<uploader-list></uploader-list><i class="images" v-show='shipi' @click="Videoshow"></i>-->
            <div  v-for="(txt,index) in goodsVideo" class="martop50" >
              <!--                <h4>课件{{index+1}}</h4>-->
              <div><video :id="'iframeId'+index" autoplay  :src="txt.url"></video></div>
              <!--                <input type="text" placeholder="请输入课件名称"  class="input_name" ref="titleInput" :id=" 'input'+index"  >-->
              <!--                <img src="./out.png" alt="" :id="'deleIco'+index" class="outs" @click="delvideo(txt,index)">-->
              <!--                <p class="upload-btn" :id="'ploadBtn'+index"><a @click="oKUpload(txt,index)">上传课件</a></p>-->
              <!--                <p class="uploadP" :id="'uploadId'+index"><img class="uploadoKImg" src="./Ok.png"/><span>视频已提交成功</span> </p>-->
            </div>

          </uploader-drop>
        </div>

        <!--图片上传-->
        <h5>图片上传（可选）</h5>
        <div class="apply-form-row">
          <div class="apply-pic">
            <div class="image-file-card">
              <label for="picPathOne" class="label-style">
                <div v-if="!picPathOne">
                  <i class="el-icon-circle-plus-outline"></i>
                  点击添加项目图片
                </div>
                <img
                  :src="picPathOne"
                  alt=""
                  v-if="picPathOne"
                  width="100%"
                  class="image-file-box"
                />
                <input
                  type="file"
                  id="picPathOne"
                  ref="picPathOne"
                  v-show="false"
                  @change="uploadImg($event, 'picPathOne')"
                  accept="image/png, image/jpeg, image/gif, image/jpg"
                />
              </label>
            </div>

            <!-- <div class="apply-pic-item" v-if="picPathOne">
              <img :src="picPathOne" alt="" />
            </div> -->

            <div class="image-file-card">
              <label for="picPathTwo" class="label-style">
                <div v-if="!picPathTwo">
                  <i class="el-icon-circle-plus-outline"></i>
                  点击添加项目图片
                </div>
                <img
                  :src="picPathTwo"
                  alt=""
                  v-if="picPathTwo"
                  width="100%"
                  class="image-file-box"
                />
                <input
                  type="file"
                  id="picPathTwo"
                  ref="picPathTwo"
                  v-show="false"
                  @change="uploadImg($event, 'picPathTwo')"
                  accept="image/png, image/jpeg, image/gif, image/jpg"
                />
              </label>
            </div>

            <div class="image-file-card">
              <label for="picPathThree" class="label-style">
                <div v-if="!picPathThree">
                  <i class="el-icon-circle-plus-outline"></i>
                  点击添加项目图片
                </div>
                <img
                  :src="picPathThree"
                  alt=""
                  v-if="picPathThree"
                  width="100%"
                  class="image-file-box"
                />
                <input
                  type="file"
                  id="picPathThree"
                  ref="picPathThree"
                  v-show="false"
                  @change="uploadImg($event, 'picPathThree')"
                  accept="image/png, image/jpeg, image/gif, image/jpg"
                />
              </label>
            </div>
          </div>
        </div>
        <h5>现场情况描述</h5>
        <div class="content-describe">
          <el-input
            class="textarea-text"
            type="textarea"
            v-model="inputText"
            size="mini"
            label-width="700px"
            :disabled="isEditConditions"
            rows="12"
            placeholder="请描述现场具体情况..."
            @input="getInput"
          ></el-input>
          <el-button
            class="btn-bj"
            type="primary"
            round
            @click="isEditConditions = false"
            >编辑</el-button>
        </div>
      </div>

      <div class="cm-form-btn">
        <div class="cu-form-btn-cz" @click="submitStep1">重置</div>
        <div class="cu-form-btn-qd" @click="submitStep2">确定</div>
      </div>
    </div>

    <!-- 地理定位 -->
    <iframe
      id="geoPage"
      width="0"
      height="0"
      frameborder="0"
      style="display: none"
      scrolling="no"
      src="https://apis.map.qq.com/tools/geolocation?key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&referer=myapp"
    ></iframe>
  </div>
</template>

<script>
import "../../../../html/components/crumbs/crumbs.scss";
import "../../../../html/pages/originality/newJxjApply/apply.scss";
import "../../../../html/pages/originality/modifyProject/modifyProject.scss";
import "../../../../html/pages/originality/newJxjApply/upload.css";
import vueupload from '../../../cases/children/detail/uopload.vue';
import './upload.css';

import {

  getJxjTags,
  uploadImage,
  subsectionUpload,
  GetJxjProUserTypes,
  GetJxjProUsers,
  jxjAddProjectLog,
  getParentProInfos,
  caseAdd,
  UploadVideo, addInfo,
} from "../../../../api";
import { mapState, mapMutations } from "vuex";

export default {
  inject :['reload'],
  components:{
    vueupload
  },
  name: "upload",
  data() {
    return {
      show: true,
      showVideo: false,
      positionInformation: {},
      picPath: "", //图片
      picPathOne: null,
      picPathTwo: null,
      picPathThree: null,
      setp: 1,
      inputText: "",
      uploadFileNum: 0, //上传进度
      videoFile: null,
      position: null, //当前地理信息
      isEditConditions: true,
      isEditConditionsOk: false,
      filePath: {
        videoPath: "",
        imageOnePath: "",
        imageTwoPath: "",
        imageThreePath: "",
      },
      fileList: [],
      index:2,
      formInfo:[
        {
          caseName:'',
          timeLong:'',
          videoUploadPercent: 0,
          videoFlag: false,
          videoForm: {showVideoPath: ''}}],
      videoForm: {showVideoPath: ''},
      options: {
        target: '/Api/Common/VueUploadVideo', // '//jsonplaceholder.typicode.com/posts/',
        testChunks: false
      },
      attrs: {
        accept: 'image/*'
      },
      statusText: {
        success: '成功了',
        error: '出错了',
        uploading: '上传中',
        paused: '暂停中',
        waiting: '等待中'
      },
      goodsVideo:[],
      VideoIndex:1,
      str1:'',
      shijian:'',
      popup:false,
      tishi_tit:'正在上传视频，请稍后。。。',
      file_tyle:0
    };
  },
  methods: {
    //文件改变调用
    // fileChange(event) {
    //   const { raw, name, url, size } = event;
    //   const fileType = [
    //     "mp4",
    //     "m3u8",
    //     "rmvb",
    //     "avi",
    //     "swf",
    //     "3gp",
    //     "mkv",
    //     "flv",
    //   ];
    //   const suffix = name.split(".");
    //   //判断是否为视频文件
    //   if (!fileType.includes(suffix[1])) {
    //     this.$message.warning("请上传视频格式文件");
    //     return false;
    //   }
    //   //判断大小最大上传200m
    //   if (size / 1024 / 1024 > 200) {
    //     this.$message.warning("只能上传200m以下文件");
    //     return false;
    //   }
    //   //是否重新选择
    //   if (this.videoFile) {
    //     this.videoFile = null;
    //     this.uploadFileNum = 0;
    //   }
    //   this.videoFile = event;
    //   const maxSize = 1024 * 1024 * 1; //单片文件容量
    //   const sectionFile = this.sectionFile(raw, size, maxSize);
    //   sectionFile.forEach(async (item) => {
    //     const upload = await item();
    //     if (upload.Name) {
    //       this.filePath.videoPath = upload.Name;
    //     }
    //     this.uploadFileNum += Math.ceil(100 / sectionFile.length);
    //     if (this.uploadFileNum == 100) {
    //       this.$message.success("上传成功");
    //     }
    //   });
    // },
    getInput() {
      if (this.inputText.length>=1) {
      this.isEditConditionsOk = true
        this.isEditConditions = false
      }else {
        this.isEditConditionsOk = false
        this.isEditConditions = true
      }
    },

    //删除视频
    delvideo(txt,index){
      this.goodsVideo.splice(index,1)
      this.onfileRemoved()
    },
    async oKUpload(txt,index){
      var inputTxt = document.getElementById('input'+index).value
      if(!inputTxt){
        this.$message.error('课件标题不能为空');
        return;
      }
      var ploadBtn = document.getElementById('ploadBtn'+index).style.cssText="display:none";
      var uploadId = document.getElementById('uploadId'+index).style.cssText="display:block";
      var deleIco = document.getElementById('deleIco'+index).style.cssText="display:none";
      document.getElementById('input'+index).setAttribute("readOnly",'true')
      var res = await caseAdd({
        ForumsId: this.$router.currentRoute.params.id,
        Title: inputTxt,
        VideoUrl: this.str1[3],
        VideoTime: this.shijian
      })
      if(res.Type == 'Success'){
        this.$message({showClose: true,message: '上传成功',type: 'success'});
      }else{
        this.$message.error(res.Content);
      }
    },

    fileSuccess (rootFile, file, message, chunk) {
      this.tishi_tit='正在转码，请稍后。。。'
      var str = chunk.processedState.res
      this.str1 = str.split('"');
      var index = this.goodsVideo.length
      this.goodsVideo.push({'url':this.str1[3],'caseName':''})
      this.showVideo = true;
      this.show = false;
      var that = this
      var t = setInterval(()=> {
        if(document.getElementById("iframeId"+index)){
          //video标签出现,获取到时间，负责给对应数据并关闭定时器
          var time = document.getElementById("iframeId" + index).duration
          if(time){
            that.shijian = time
            that.popup=false
            clearInterval(t);
          }
        }
      },500)


    },
    //文件添加时回调，这里可以做格式校验，md5计算
    onFileAdded(file){
      console.log('onFileAdded')
      this.popup=true
      if(file.size >=1024*1024*200){
        file.pause()
        this.$message({showClose: true,message: '上传文件不可超过200MB'});
        return
      }
      var video = ['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv']
      let file_type = file.name.substring(file.name.lastIndexOf(".") + 1);
      for(var i = 0; i< video.length; i++ ){
        const extension = file_type === video[i];
        console.log(video[i])
        if (extension) {
          break;
        }else{
          this.popup=false
          this.file_tyle = -1
          file.pause();
        }

      }
      if(this.file_tyle == -1){
        this.$message({showClose: true,message: "不支持当前后缀格式"});
      }

    },

    //删除视频
    onfileRemoved(file){

    },
    //文件上传的过程中会频繁调用该函数
    onFileProgress(rootFile, file, chunk){
      console.log('onFileProgress')
      console.log(rootFile, file, chunk)

    },
    //文件上传出错的回调
    onFileError(rootFile, file, msg, chunk){
      console.log('onFileError')
      console.log(rootFile, file, msg, chunk)
    },
    fileComplete () {
    },
    VideoLoad(e){
    },
    fileChange(file) {
      if (!file.size) return;
      this.fileList.push(file);
    },
    onProgress(file, percent, index) {
      console.log(percent)
      this.formInfo[index].videoUploadPercent = percent * 100;
      // $(`.file-${file.id} .progress`).css('width', percent * 100 + '%');
      // $(`.file-${file.id} .file-status`).html((percent * 100).toFixed(2) + '%');
    },
    onSuccess (file, response, index) {
      this.formInfo[index].videoForm.showVideoPath = response.Name;
      this.index = 10;
      //不断获取视频时间，直到获取到为止
      let that = this
      let t = setInterval(()=> {
        if(document.getElementById("V"+index)){
          //video标签出现,获取到时间，负责给对应数据并关闭定时器
          let time = document.getElementById("V" + index).duration
          if(time){
            that.formInfo[index].timeLong = time;
            clearInterval(t);
          }

        }
      },500)
      if (response.needMerge) {
        let res= UploadVideo({
          tempName: response.tempName,
          fileName: file.name
        })
        let $fileStatus = $(`.file-${file.id} .file-status`);
        if (res.status === 0) {
          $fileStatus.html('上传成功，转码中');
        } else if (res.status === 1) {
          $fileStatus.html('上传失败');
        } else if (res.status === 2) {
          $fileStatus.html('上传成功');
        }
      }
    },
    resume(file) {
      this.uploader.upload(file);
    },
    stop(file) {
      this.uploader.stop(file);
    },
    remove(file) {
      // 取消并中断文件上传
      this.uploader.cancelFile(file);
      // 在队列中移除文件
      this.uploader.removeFile(file, true);
      // 在ui上移除
      let index = this.fileList.findIndex(ele => ele.id === file.id);
      this.fileList.splice(index, 1);
    },
    fileSize(size) {
      return WebUploader.Base.formatSize(size);
    },
    fileCategory(ext) {
      let type = '';
      const typeMap = {
        //image: ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp'],
        video: ['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv'],
        //text: ['doc', 'txt', 'docx', 'pages', 'epub', 'pdf', 'numbers', 'csv', 'xls', 'xlsx', 'keynote', 'ppt', 'pptx']
      };
      Object.keys(typeMap).forEach((_type) => {
        const extensions = typeMap[_type];
        if (extensions.indexOf(ext) > -1) {
          type = _type
        }
      });
      return type
    },


    /**
     * 读取文件流
     *  @params {file} 原始文件流
     *  @param {type} 要转换的格式 arrayBuffer = readAsArrayBuffer; dataUrl = readAsDataUrl
     */
    fileReader(file, type = "readAsArrayBuffer") {
      return new Promise((resolve) => {
        //文件读取对象
        const fileReader = new FileReader();
        //根据类型解析文件
        switch (type) {
          case "arrayBuffer":
            fileReader.readAsArrayBuffer(file);
            break;
          case "dataUrl":
            fileReader.readAsDataURL(file);
        }
        fileReader.onload = (res) => {
          resolve(res.currentTarget.result);
        };
      });
    },

    /**
     * 创建文件切片
     *  @params {file} 文件流
     *  @param {fileSize} 文件流总大小
     *  @param {sliceSize} 每片大小 默认为20m
     */
    sectionFile(file, fileSize, sliceSize = 1024 * 1024 * 1) {
      let fileSliceArr = [];
      for (let i = 0; i <= fileSize; i += sliceSize) {
        fileSliceArr.push(file.slice(i, sliceSize));
      }
      return this.uploadVideo(fileSliceArr, sliceSize);
    },

    //创建请求
    uploadVideo(fileSliceArr = [], sliceSize) {
      const subsectionResArr = [];
      fileSliceArr.forEach((buffer, index) => {
        const resFn = async () => {
          const formData = new FormData();
          formData.append("file", buffer);
          formData.append("chunkNumber", index + 1);
          formData.append("chunkSize", sliceSize);
          formData.append("totalSize", this.videoFile.size);
          formData.append(
            "identifier",
            this.videoFile.size + "-" + this.videoFile.name
          );
          formData.append("filename", this.videoFile.name);
          formData.append("relativePath", this.videoFile.url);
          formData.append("totalChunks", fileSliceArr.length);
          return subsectionUpload(formData);
        };
        subsectionResArr.push(resFn);
      });
      return subsectionResArr;
    },

    // 视频上传
    handleRemove(file, fileList) {},
    handlePictureCardPreview(file) {},

    // 图片上传
    async uploadImg(e, type) {
      const imgFile = e.target.files[0];
      //直接上传二进制文件
      const imagePath = await uploadImage({
        file: imgFile,
      });
      //根据不同类型执行不同操作
      switch (type) {
        case "picPathOne":
          this.picPathOne = await this.fileReader(imgFile, "dataUrl");
          this.filePath.imageOnePath = imagePath.Data;
          break;
        case "picPathTwo":
          this.picPathTwo = await this.fileReader(imgFile, "dataUrl");
          this.filePath.imageTwoPath = imagePath.Data;
          break;
        case "picPathThree":
          this.picPathThree = await this.fileReader(imgFile, "dataUrl");
          this.filePath.imageThreePath = imagePath.Data;
          break;
      }
      addInfo({
        Id:this.$route.query.Id,
        PicPath: imagePathStr.toString(),
      }).then(res=>{
        console.log(res)
      })
    },

    //定位
    Tmap() {
      window.addEventListener(
        "message",
        (event) => {
          this.position = event.data;
        },
        false
      );
    },

    //重置
    submitStep1() {
      this.picPathOne = null;
      this.picPathTwo = null;
      this.picPathThree = null;
      this.inputText = "";
      this.uploadFileNum = 0;
      this.videoFile = null;
      this.isEditConditions = true;
      this.isEditConditionsOk = true;
    },
    //确定
    submitStep2() {
      //处理图片路径
      const imagePathStr = [];
      for (let i in this.filePath) {
        if (i != "videoPath" && this.filePath[i] != "") {
          imagePathStr.push(this.filePath[i]);
        }
      }
      addInfo({
        Id:this.$route.query.Id,
        SignUpPoint:this.position.lat + "," + this.position.lng,
        SignUpAddr:this.position.province + this.position.city,
        VideoUrl:this.goodsVideo[0].url,
        PicPath:imagePathStr.toString(),
        SiteContent: this.inputText,
      }).then(res=>{
        console.log(res)
        //跳转下一步流程并携带参数
        this.$router.push({
          path: "newJxjApply",
          query: {
            Id:this.$route.query.Id,
          },
        });
      })

    },
  },
  computed: {
    ...mapState(["userInfo"]),
    uploader() {
      return this.$refs.uploader;
    }
  },
  created() {},
  mounted() {
    this.Tmap();
    var toduId= this.$route.query.Id

  },
};
</script>

<style scoped>
.g-container {
  width: 100%;
  /*height: 940px;*/
  background: #ffffff;
  font-size: 16px;
}

.upload-title-sing {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #545454;
}

.upload-sign {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #c8c8c8;
  color: #666666;
}

.upload-sign-positioning {
  width: 20%;
  padding-left: 30px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.upload-sign-right {
  padding-right: 600px;
}

.apply-orig-main {
  min-height: 50px;
  padding: 0;
  margin: 0 auto;
  background: #fff;
  margin-bottom: 40px;
  border: 0;
}

.content {
  width: 100%;
  margin-top: 50px;
}

.content h5 {
  margin-bottom: 20px;
  color: #545454;
  font-size: 16px;
}

.apply-form-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0px;
}

.apply-pic {
  width: 700px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 50px;
}
.apply-pic-item {
  width: 225px;
  height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.apply-pic .apply-pic-item .upload-btn {
  width: 225px;
  height: 260px;
  line-height: 100px;
  background: #f4f4f4;
  border-radius: 15px;
  color: #c8c8c8;
  border: 0;
  font-size: 16px;
}

.content-upload-video {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;
}

.cm-form-btn {
  border: 0;
  margin-top: 100px;
}

.cm-form-btn .cu-form-btn-cz {
  width: 140px;
  height: 40px;
  background: #b8b8b8;
  border-radius: 20px;
  line-height: 40px;
  color: #ffffff;
  margin-right: 10px;
}

.cm-form-btn .cu-form-btn-qd {
  width: 140px;
  height: 40px;
  background: #ff0000;
  border-radius: 20px;
  line-height: 40px;
  color: #ffffff;
  margin-left: 10px;
}

.content-describe {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-bj {
  position: absolute;
  bottom: 10px;
  right: 250px;
  width: 120px;
  height: 40px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.textarea-text {
  width: 700px;
  height: 300px;
  background: #f4f4f4;
  border-radius: 15px;
  font-size: 16px;
}

/deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
}

/deep/ .el-upload {
  width: 700px;
  height: 300px;
  line-height: 100px;
  background: #f4f4f4;
  border-radius: 15px;
  color: #c8c8c8;
  font-size: 16px;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

/deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

/deep/ .avatar {
  width: 100px;
  height: 100px;
}
.el-upload--picture-card i {
  padding-top: 20%;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #c8c8c8;
}
.el-progress {
  margin-top: 75px;
}
.image-file-card {
  width: 225px;
  height: 260px;
  background: #f4f4f4;
  border-radius: 15px;
  color: #c8c8c8;
}
.label-style {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-file-box {
  max-height: 100%;
}
.uploader {
  width: 700px;
  height: 300px;
}
.uploader-btn {
  width: 684px;
  height: 300px;
  position: relative;
  line-height: 1.8;
  border: 0;
  background: #F4F4F4;
  border-radius: 15px;
}
  .upload-btnP{
    position: absolute;
    top: 42%;
    left: 42%;
  }
.uploader-drop {
  width: 684px;
  height: 300px;
  border: 0;
  background: #F4F4F4;
  border-radius: 15px;
}
</style>